"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPassword = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@food/ui/build/dist/src/Button");
const Field_1 = require("@food/ui/build/dist/src/Field");
const SocialLogin_1 = require("./SocialLogin");
const css_manager_1 = require("@food/css-manager");
const flexRow = (0, css_manager_1.registerClass)(() => `
	flex-direction: row;
`);
const flexCol = (0, css_manager_1.registerClass)(() => `
	flex-direction: column;
`);
const stepSection = (0, css_manager_1.registerClass)((theme, sc) => `
	padding: ${(theme.ratios.l / 4) * theme.font.baseSize}px ${theme.ratios.l *
    theme.font.baseSize}px;

	> div {
		display: flex;
		justify-content: space-between;
		
		> div {
			margin: ${(theme.ratios.l / 2) * theme.font.baseSize}px;
			flex-grow: 1;
		}
	}
	
	.${sc('return-to-login')} {
		text-align: center;
	}
	
	.${sc('reset-button')} {
		text-align: center;
		margin-bottom: ${theme.ratios.l * theme.font.baseSize}px;
	}
	
	.${sc('error')} {
		color: red;
		margin-bottom: ${theme.ratios.l * theme.font.baseSize}px;
	}
	
	&.${sc('layout', 'STANDARD')} > div > div {
		flex-basis: ${theme.font.baseSize}px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
`);
const sc = (...args) => (0, css_manager_1.subClass)(stepSection, ...args);
const marginBottom = (0, css_manager_1.registerClass)((theme) => `margin-bottom: ${theme.ratios.l * theme.font.baseSize}px;`);
class ResetPassword extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.setEmail = (event) => {
            this.setState({ email: event.target.value });
        };
        this.isValidEmail = (email) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        };
        this.requestPasswordReset = async () => {
            this.setState({ error: null });
            const { email } = this.state;
            const { config } = this.props;
            if (!this.isValidEmail(email)) {
                this.setState({
                    error: 'Please enter a valid email address',
                    requestPerformed: false,
                });
                return;
            }
            try {
                const response = await fetch(config.RESET_PASSWORD_ENDPOINT ??
                    'https://api2.italianfood.net/api/forgot-password', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        'X-Target-Site': 'FOODWEB', // TODO check why this won't work -> config.TARGET_SITE || 'IFN',
                    },
                    body: JSON.stringify({
                        sourceApp: config.TARGET_SITE || 'FOODWEB',
                        email: email,
                        changePasswordPath: config.RESET_PASSWORD_WP_PATH ??
                            '/ripristina-password/#/confirm/',
                        changePasswordHost: config.RESET_PASSWORD_WP_HOST ?? 'stage.foodweb.it',
                        redirectUrl: config.RESET_PASSWORD_REDIRECT_URL,
                        redirectLabel: config.RESET_PASSWORD_REDIRECT_LABEL ?? 'Torna su HUB',
                    }),
                });
                const result = await response.json();
                if (result.success) {
                    this.setState({
                        requestPerformed: true,
                        error: null,
                    });
                }
                else {
                    this.setState({
                        requestPerformed: false,
                        error: result.message ||
                            'An error occurred while requesting password reset',
                    });
                }
            }
            catch (err) {
                this.setState({
                    requestPerformed: false,
                    error: err instanceof Error ? err.message : 'Network error occurred',
                });
            }
        };
        this.state = {
            email: '',
            requestPerformed: null,
            error: null,
        };
    }
    render() {
        const { email, error, requestPerformed } = this.state;
        const { loading, logoElem, t, layout } = this.props;
        if (loading) {
            return (react_1.default.createElement("section", null,
                t `loading`,
                "..."));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h2", null, t `Reset your password`),
            react_1.default.createElement("section", { className: (0, css_manager_1.classNames)(stepSection, sc('layout', layout)) },
                react_1.default.createElement("div", { className: layout === SocialLogin_1.SOCIAL_LOGIN_LAYOUTS.STANDARD
                        ? flexRow
                        : flexCol },
                    logoElem,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", null, requestPerformed
                            ? t `We sent an email to this address:`
                            : t `Enter your email address:`),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("form", { onSubmit: (e) => {
                                    e.preventDefault();
                                    this.requestPasswordReset();
                                } },
                                react_1.default.createElement(Field_1.Field, null,
                                    react_1.default.createElement("input", { className: marginBottom, type: 'email', placeholder: "you@domain.com", value: email, onChange: this.setEmail })),
                                error && react_1.default.createElement("div", { className: sc('error') }, error),
                                requestPerformed && (react_1.default.createElement("div", { className: marginBottom }, t('Check your inbox, including spam. If you don\'t receive anything within a few minutes, verify the email address and try again.'))),
                                react_1.default.createElement("div", { className: sc('reset-button') },
                                    react_1.default.createElement(Button_1.Button, { disabled: !email || !this.isValidEmail(email), label: requestPerformed ? t('Send again') : t('Reset your password'), type: requestPerformed ? 'info' : 'success', onClick: () => {
                                            this.requestPasswordReset();
                                        } })))),
                        react_1.default.createElement("div", { className: sc('return-to-login') },
                            react_1.default.createElement(Button_1.Button, { label: t `Return to login`, layout: Button_1.layouts.LINK, onClick: () => {
                                    this.props.onGoBack();
                                } })))))));
    }
}
exports.ResetPassword = ResetPassword;
//# sourceMappingURL=ResetPassword.js.map